import { getSessionToken } from "./session";

export interface UploadedAvatar {
  readonly id: string;
  readonly contentType: string;
  readonly sizeBytes: number;
  readonly updatedAt: number;
}

function endpoint(): string {
  const value = import.meta.env.VITE_GAME_API_URL as string | undefined;
  if (!value) throw new Error("联网头像服务尚未配置");
  return value.replace(/\/$/u, "");
}

export function avatarImageUrl(id: string): string {
  const value = import.meta.env.VITE_GAME_API_URL as string | undefined;
  const base = value?.replace(/\/$/u, "") ?? "";
  return `${base}/avatars/${encodeURIComponent(id)}`;
}

export const userAvatarApi = {
  async upload(file: File): Promise<UploadedAvatar> {
    const token = getSessionToken();
    if (!token) throw new Error("请先登录后上传头像");
    const form = new FormData();
    form.set("file", file);
    const response = await fetch(`${endpoint()}/me/avatar`, {
      method: "POST",
      headers: { authorization: `Bearer ${token}` },
      body: form,
    });
    if (!response.ok) {
      const value = (await response.json().catch(() => null)) as {
        error?: { message?: string };
      } | null;
      throw new Error(value?.error?.message ?? "头像上传失败，请重试");
    }
    const value = (await response.json()) as { avatar?: UploadedAvatar };
    if (!value.avatar || !/^[0-9a-f]{8}-[0-9a-f-]{27}$/iu.test(value.avatar.id))
      throw new Error("头像服务响应无效");
    return value.avatar;
  },
};
